import { connect } from 'react-redux';
import { setActiveActivity, toggleActivityVisibility } from '../Actions';
import TrackSelector from '../components/trackSelector/TrackSelector';
const mapStateToProps = state => ({
    activeTrack: state.tracks.activeTrack,
    tracks: Object.keys(state.activities)
        .filter(a => state.activities[a].focusable && state.tracks.tracks[a] && state.tracks.tracks[a].length > 0)
        .map(a => ({
        activityId: state.activities[a].activityId,
        avatar: state.activities[a].avatar,
        color: state.activities[a].color,
        show: state.activities[a].show,
        active: a === state.tracks.activeTrack,
    })),
});
const mapDispatchToProps = dispatch => ({
    setTarget: targetId => {
        dispatch(setActiveActivity(targetId));
    },
    toggleVisibility: targetId => {
        dispatch(toggleActivityVisibility(targetId));
    },
    closeMenu: () => {
        dispatch({ type: 'CLEAR_MODAL' });
        dispatch({ type: 'POP_PAUSE' });
    },
    setModal: modal => {
        dispatch({ type: 'SET_MODAL', modalType: modal });
        dispatch({ type: 'PUSH_PAUSE' });
    },
});
const TrackSelectorControl = connect(mapStateToProps, mapDispatchToProps)(TrackSelector);
export default TrackSelectorControl;
